"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var CTA = /** @class */ (function (_super) {
    __extends(CTA, _super);
    function CTA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createMarkup = function (value) { return ({ __html: value }); };
        return _this;
    }
    CTA.prototype.render = function () {
        var settings = this.props.section.settings;
        var foreground = settings && settings.foreground ? settings.foreground.toLowerCase() : "arctic";
        var background = settings && settings.background ? settings.background.toLowerCase() : "navy";
        var horizontal = settings && settings.horizontal ? settings.horizontal.toLowerCase().replace("left", "start").replace("right", "end") : "center";
        var contentClasses = [];
        contentClasses.push("justify-center md:justify-" + horizontal);
        contentClasses.push("items-end md:items-center");
        return (React.createElement(Snippets.Container, { width: settings.fullwidth ? "full" : "xl mlg:px-11", className: "theme-cta" + (settings.verticalspacing ? " my-3-2 md:my-6-4" : ""), tag: "section" },
            React.createElement("a", { className: "flex flex-col md:flex-row w-full", href: settings.linkurl ? settings.linkurl : "" },
                React.createElement("div", { className: "relative w-full" },
                    React.createElement("div", null, settings.title || (settings.linkurl && settings.linktext) ? (React.createElement("div", null,
                        React.createElement(Snippets.Image, { bg: background, className: "bg-cover bg-center absolute pin hidden md:block", src: settings.image }),
                        React.createElement(Snippets.Image, { bg: background, className: "bg-cover bg-center absolute pin block md:hidden", src: settings.imagemobile ? settings.imagemobile : settings.image }))) : (React.createElement("div", null,
                        React.createElement(Snippets.Image, { bgNatural: true, className: "bg-cover bg-center hidden md:block w-full", src: settings.image }),
                        React.createElement(Snippets.Image, { bgNatural: true, className: "bg-cover bg-center block md:hidden", src: settings.imagemobile ? settings.imagemobile : settings.image })))),
                    settings.overlay ? (React.createElement("div", { className: "absolute pin " + (settings.overlay === 100 ? "bg-midnight-gradient" : "bg-smoke"), style: { opacity: settings.overlay / 100 } })) : null,
                    settings.title || (settings.linkurl && settings.linktext) ? (React.createElement(Snippets.Container, { width: "lg", collapsed: true, className: "pin flex w-full py-3 px-7-3 text-center md:px-9 " + contentClasses.join(" ") },
                        React.createElement("div", { className: "flex w-full z-10 items-center flex-col md:flex-row " },
                            React.createElement("div", { className: "flex flex-grow items-center" }, settings.title ? (React.createElement("div", { className: "text-" + foreground + " font-extrabold md:text-36 text-xmd md:leading-tightest leading-normal mobile:text-center", dangerouslySetInnerHTML: this.createMarkup(settings.title) })) : null),
                            settings.linktext && settings.linkurl ? (React.createElement(Snippets.Button
                            // href={settings.linkurl}
                            , { 
                                // href={settings.linkurl}
                                style: "chevron", className: "flex h-4-8 pt-0-4 items-center mt-2-4 md:mt-0 rounded w-full uppercase px-2-4 max-w-32", reverse: foreground != "midnight" }, settings.linktext)) : null))) : null))));
    };
    CTA.sectionId = "cta";
    return CTA;
}(React.PureComponent));
exports.CTA = CTA;
